export default {
    'font': '字体',
    'font.size': '字号',
    'font.default': '默认'
};



